<!--
 * @Author: your name
 * @Date: 2022-01-11 18:03:20
 * @LastEditTime: 2022-01-24 15:34:07
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/changma202201/components/test.vue
-->
<template>
  <div class="testchangma">
    <mt-swipe @change="change" class="mt-swiper container" :auto="5000">
      <mt-swipe-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.img" alt="" />
        <videoComp :poster="item.poster" :ref="'video'+index" :src="item.src"></videoComp>
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>

<script>
import videoComp from "./video.vue";
export default {
  name: "app",
  components:{
    videoComp
  },
  data() {
    var vm = this;
    return {
      galleryTop: null,
      galleryThumbs: null,
      imgList: [
        {
          src: "https://source.qunarzz.com/site/images/wns/se-1.mp4",
          className: "t1",
          href: "https://aaag9.package.qunar.com/user/detail.jsp?abt=a&id=1094538572&",
          isStart: true,
          poster:"https://s.qunarzz.com/srmweb/qunaradv/changma202201/37.png",
          img: "https://s.qunarzz.com/srmweb/qunaradv/changma202201/3.png",
        },
        {
          src: "https://source.qunarzz.com/site/images/wns/se-2.mp4",
          isStart: true,
          href: "https://aaag9.package.qunar.com/user/detail.jsp?abt=a&id=1600682952&",
          className: "t2",
          poster:"https://s.qunarzz.com/srmweb/qunaradv/changma202201/36.png",
          img: "https://s.qunarzz.com/srmweb/qunaradv/changma202201/24.png",
        },
      ],
    };
  },
  methods: {
    // errorFn(){
    //   this.galleryTop.slideTo(1, 0, false);
    //   this.videoList[0].isStart = false;
    // },
    change(e){
      this.$refs['video'+(e == 0 ? 1:0)][0].pause();
    },
    initSwiper(initialSlide) {
      console.log("initSwiper");
      this.galleryThumbs = new Swiper(".gallery-top .swiper-container", {
        pagination: {
          el: ".gallery-top .swiper-pagination",
        },
        autoplay: {
          delay: 5000,
        },
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper(0);
    });
  },
};
</script>

<style lang="less" scoped="true">
.mt-swiper {
  height: 580px;
  width: 286px;
  img{
    height:360px;
  }
}
.testchangma {
  width: 342px;
  background: #b6c8d3;
  border: 2px solid;
  border-image: linear-gradient(-36deg, #f2eae2, #dbb99a, #faf9f4, #f2eae2) 2 2;
  box-shadow: 0px 1px 2px 0px rgba(158, 185, 201, 0.82);
  padding-left:28px;
  padding-right:28px;
  padding-top:21px;
  padding-bottom:21px;
  box-sizing: border-box;
}
</style>
